export const stepOption = [
    {
        value: "1", title: "Выявление новых случаев", type: "input", level: 1,
        data: [3800, 4001, 4211, 4520, 4771, 4835, 4968, 5010, 5253, 4096],
        dataPredictor: 112,
        cr2:  `${process.env.PUBLIC_URL}/images/img/card_02.jpg`,
        typex: "stage"
    },
    {value: "p1", title: "Подлежат лечению", col: 1.5, level: 2,
    typex: "input",        cr: `${process.env.PUBLIC_URL}/images/pdf/cr/KP134.pdf`,},
    {value: "p2", title: "Не подлежат лечению", col: 2.5, level: 2,  description: "На основании данных ГРР, установлено, что только 65% пациентов подлежат специализированному лечению, и получают его. Остальные пациенты получают симптоматическое лечение. В случае, если вы обладаете более полной информацией по терапии, укажите значение в разделе 'Уточнения/Подлежат лечению'"},

    {value: "q1", title: "Группа I", col: 1, level: 3, description: " Молодые пациенты (менее 65 лет) без делеции 17p и/или мутации\n" +
            "TP53 с хорошим соматическим статусом без сопутствующих заболеваний. В этой группе\n" +
            "необходимо стремиться к достижению полной ремиссии, по возможности с эрадикацией\n" +
            "МОБ, поскольку только такая тактика может привести к реальному увеличению\n" +
            "продолжительности жизни. Основа лечения пациентов этой группы – курсовая\n" +
            "иммунохимиотерапия. В подгруппе пациентов без мутаций генов IGHV комбинация\n" +
            "ибрутиниба** и ритуксимаба** оказалась значительно более эффективной и менее\n" +
            "токсичной по сравнению с режимом FCR. У пациентов без мутаций генов IGHV может\n" +
            "рассматриваться возможность терапии ибрутинибом."},
    {value: "q2", title: "Группа II", col: 2, level: 3, description: "Пациенты преклонного возраста (старше 65 лет), а также молодые\n" +
            "пациенты со множеством сопутствующих заболеваний. В этой группе нужно стремиться к\n" +
            "достижению эффективного контроля над опухолью, избегая неоправданной токсичности.\n" +
            "Аналоги пуринов в этой группе лучше не использовать или применять в редуцированном виде."},
    {value: "q3", title: "Группа III", col: 3, level: 3, description: "Пациенты с делецией 17p и/или мутацией TP53 независимо от\n" +
            "возраста и коморбидности. Терапией выбора у этих пациентов является применение\n" +
            "ибрутиниба** в монорежиме. У молодых пациентов при возможности терапия\n" +
            "ибрутинибом** должна служить подготовкой к трансплантации аллогенных стволовых\n" +
            "клеток."},

    {value: "l2", title: "Таргетная терапия, 7 схем", col: 2, level: 4},

    {value: "e1", title: "Выбор терапии, I", col: 1, level: 4, description: ""},
    {value: "e2", title: "Выбор терапии, III", col: 3, level: 4, description: ""},

    {value: "z8", title: "Прогрессирование", col: 1, level: 5, description: "", noCalc: true},
    {value: "z9", title: "Вторая линия", col: 1, level: 6, description: "", noCalc: true},
    {value: "z10", title: "Ибрутиниб", col: 2, level: 6, description: "", noCalc: true},
    {value: "z11", title: "Прочая терапия", col: 3, level: 6, description: "", noCalc: true},
    {value: "z12", title: "ТКМ", col: 2.5, level: 7, description: "", noCalc: true},
]




export const stepConnection = [
    {source: "1", target: "p1", label: "65%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "M1", task: ["sender", "value"]}},
    {source: "1", target: "p2", label: "65%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "M1", task: ["sender", "value"], negative: true}},

    {source: "p1", target: "q1", label: "65%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "M2", task: ["sender", "value"]}},
    {source: "p1", target: "q2", label: "65%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "M3", task: ["sender", "value"]}},
    {source: "p1", target: "q3", label: "65%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "M4", task: ["sender", "value"]}},

    {source: "q2", target: "l2", label: "", sender: {value: "1", ttl: "1"}, },
    {source: "q1", target: "e1", label: "", sender: {value: "1", ttl: "1"}, },
    {source: "q3", target: "e2", label: "", sender: {value: "1", ttl: "1"}, },

    {source: "e1", target: "z8", label: "",    },
    {source: "z8", target: "z9", label: "",    },
    {source: "e2", target: "z10", label: "",   },
    {source: "e2", target: "z11", label: "",   },
    {source: "z10", target: "z12", label: "",  },
    {source: "z11", target: "z12", label: "",  },
]

export const modeling = [
    {
        value: "h1x", source: "q2", title: "Новая терапия (ГР I)", selector: 'H1', kmv:
            {
                A: [0.52, 0.18],
                B: [0.67, 0.63]
            },
    },
    {
        value: "h2x", source: "q3", title: "Новая терапия (ГР 3)", selector: 'H2', kmv:
            {
                A: [0.52, 0.18],
                B: [0.67, 0.63]
            },
    }
]


export const mainTrends = {
    stageI_II: {
            data: [0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0],
            ltr: 0.0
        },
        live5y: {
            data: [47.66,  48.89,  48.90,  49.42,  49.97,  50.27,  51.92,  52.53,  52.74,  54.66,  55.84],
            ltr: 0.76
        },
        live1y: {
            data: [21.31,  19.47,  18.93,  17.93,  17.47,  16.53,  16.55,  14.91,  14.45,  14.27,  14.01],
            ltr: -0.22
        },
        dnl: {
            data: [49,        50,     51,     52,    53,      54,     55, 56,      57,   58,    59],
            ltr: 1
        },


    live1yttl: {
        data: [27.38, 26.09, 25.32, 24.77, 23.58, 23.25, 22.51, 22.25, 21.68, 20.60],
        ltr: -0.69
    },
    live5yttl: {
        data: [51.34,	51.07,	51.67,	52.43,	52.92,	53.34,	53.94,	54.45,	55.33,	56.57],
        ltr: 0.58
    },
}



const Model = {
    stepOption,
    stepConnection,
    modeling,
    mainTrends,
    defaultStrategy: {
        H1A: '0', H2A: '0', H3A: '0',
            H1B: '20', H2B: '25', H3B: '30',
            M1: '65',
            M2: '45',
            M3: '40',
            M4: '15'
    },
    name: "Хронический лимфоцитарный лейкоз",
    vars: {
    strategy: [
        {title: "Доля терапии Ибрутиниб, ГРУППА I, %", prefix: "H1"},
        {title: "Доля терапии Ибрутиниб, ГРУППА III, %", prefix: "H2"},
    ],
        mutation: [
        {title: "Подлежат лечению, %", prefix: "M1"},
        {title: "Группа I, %", prefix: "M2"},
        {title: "Группа II, %", prefix: "M3"},
        {title: "Группа III, %", prefix: "M4"},
    ]
},
    options: {
        showTrends: true,
            mainView: {
            title: "Общая информация",
                lines: [
                {key: "1", title: "Всего"},
                {key: "p1", title: "Подлежат лечению"},
            ]
        }
    },
}

export default Model